import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Normalize FastAPI/Pydantic validation errors (detail as array/object) into a readable string.
// Prevents "Objects are not valid as a React child" when rendering error.response.data.detail.
const normalizeDetail = (detail) => {
  if (detail == null) return detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object' && d.msg) {
          const msg = String(d.msg).replace(/^Value error,\s*/i, '');
          const field = Array.isArray(d.loc) ? d.loc.filter((l) => l !== 'body').join('.') : '';
          return field ? `${field}: ${msg}` : msg;
        }
        return JSON.stringify(d);
      })
      .join(', ');
  }
  if (typeof detail === 'object') {
    return detail.msg || JSON.stringify(detail);
  }
  return String(detail);
};

// Interceptor to handle automatic logout on 401 Unauthorized
api.interceptors.response.use(
  (response) => {
    // Aktivitas ke server memperpanjang sesi (lihat hooks/useSessionTimeout.js)
    if (typeof window !== 'undefined') window.dispatchEvent(new Event('hisa-api-activity'));
    return response;
  },
  (error) => {
    if (error.response && error.response.data && 'detail' in error.response.data) {
      error.response.data.detail = normalizeDetail(error.response.data.detail);
    }
    if (error.response && error.response.status === 401) {
      // Dispatch a custom event that AuthContext can listen to
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
